/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */


(function () {
  'use strict';
  angular.module('vcdrug')
    .component('drugforeign', {
      restrict: 'E',
      bindings: {
        patientid: '<'
      },
      template: `
        <h4>Fremdverordnung vermerken</h4>
        <form class="form-vertical" name="newfdrugform">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <label for="newfdrugname">Medikament <span uib-tooltip="Plichtfeld">*</span><sprhelp tip="Geben Sie mindestens 3 Zeichen um die Suche zu starten"></sprhelp></label>
                    <input class="form-control" ng-model="vm.newfdrug.name"
                           type="text" class="form-control" placeholder="Medikament oder PharmaNr."
                           autocomplete="noway"
                           typeahead-on-select="vm.showfdruginfo($item)"
                           typeahead-min-length="3"
                           uib-typeahead="drug as drug.text for drug in vm.getDrugs($viewValue)"
                           typeahead-loading="loadingNames"
                           id="newfdrugname"
                           select-first-match="false"
                           typeahead-no-results="vm.noFDResults"
                           required
                    />
                    <div ng-show="vm.noFDResults" style="color: #cc3333; font-weight: bold">
                        <i class="fa fa-warning"></i> Keine Medikamente gefunden!
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-group">
                        <label for="fdrugamount">Einnahme <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Ausw&auml;hlen oder eingeben" descref="vm.sprsignature"></sprhelp> </label>
                        <div class="input-group">
                            <input class="form-control" ng-model="vm.newfdrug.amount" id="fdrugamount"
                                   autocomplete="noway" autocorrect="off" autocapitalize="off" spellcheck="false"
                                   placeholder="1-0-1-0" required ng-class="{ 'has-error': newfdrugform.$invalid }">
                            <div class="input-group-btn" uib-dropdown>
                                <button type="button" class="btn btn-default" uib-dropdown-toggle><span class="caret"></span>
                                </button>
                                <ul id="famountmenu" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu>
                                    <li ng-click="vm.newfdrug.amount='1-0-0'">1-0-0</li>
                                    <li ng-click="vm.newfdrug.amount='1-0-1'">1-0-1</li>
                                    <li ng-click="vm.newfdrug.amount='0-1-0'">0-1-0</li>
                                    <li ng-click="vm.newfdrug.amount='0-0-1'">0-0-1</li>
                                    <li ng-click="vm.newfdrug.amount='1-1-1'">1-1-1</li>
                                    <li ng-click="vm.newfdrug.amount='0-0-0-1'">0-0-0-1</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <button class="btn btn-success" type="submit" ng-disabled="!newfdrugform.$valid"
                            ng-click="vm.addForeignDrug()">
                       <span ng-show="vm.drug_saved"><i class="fa fa-check" ></i>&nbsp;Fremdverordnung gespeichert</span>
                       <span ng-hide="vm.drug_saved">Fremdverordnung speichern</span>
                    </button>
                </div>
            </div>
        
        </form>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Drug', 'Med', 'vertxEventBusService', '$element', 'lodash', '$sce', 'Config', '$timeout', '$window',
        function ($log, Rlog, Drug, Med, vertxEventBusService, $element, _, $sce, Config, $timeout, $window) {
          let vm = this;
          vm.ready = 'loading';
          vm.data = null;
          vm.getDrugs = getDrugs;
          vm.showfdruginfo = showfdruginfo;
          vm.addForeignDrug = addForeignDrug;


          vm.$onInit = function () {
            vm.newfdrug = {};

            Config.$find('drugconfig').$then(function (sigs) {
              //  vm.conf.drugsignature.length
              vm.conf = sigs;
              // intialize if still empty
              if (!angular.isArray(vm.conf.drugsignature)) {
                vm.drugsignature.drugsignature = [];
              }
              if (!angular.isString(vm.conf._id)) {
                vm.drugsignature._id = 'drugconfig';
              }
            });
          };


          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
              vm.patientid = changes.patientid.currentValue;
              Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
                $log.info('found existing patdrug record: ', drugs);
                vm.patdrugs = drugs[0];
                vm.ready = true;
              });
            }
          };


          // drugahead drug name completion
          function getDrugs(val) {
            console.log('loading drug names');
            vm.newdrug = {};
            return Med.$searchahead({query: val}).$asPromise().then(function (response) {
              // console.log('drug search response: ', response);
              return response.map(function (drug) {
                if (angular.isString(drug.amount) && angular.isString(drug.amounttype)) {
                  drug.text = drug.name + ' (' + drug.amount + drug.amounttype + ')';
                } else {
                  drug.text = drug.ZBEZ + ' (' + drug.ZLNUMM + ')';
                }
                return drug;
              });
            });
          }

          // show foreign drug info
          function showfdruginfo($item) {
            /* jshint unused:false */
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            vm.newfdrug = {};

            $log.debug('showfdruginfo called: ', $item);
            vm.selectedfDrug = $item;

            if (angular.isString(vm.selectedfDrug.name)) {
              vm.newfdrug.name = vm.selectedfDrug.name;
            } else {
              vm.newfdrug.name = vm.selectedfDrug.ZBEZ;
            }

            vm.newfdrug.permanent = true;


            // Pharmanr
            if (angular.isString(vm.selectedfDrug.pharmanr)) {
              vm.newfdrug.pharmanr = vm.selectedfDrug.pharmanr;
            }

            // Zulassungsnummer
            if (angular.isString(vm.selectedfDrug.ZLNUMM)) {
              vm.newfdrug.ZLNUMM = vm.selectedfDrug.ZLNUMM;
            }

            // Array aller ATC codes
            if (angular.isArray(vm.selectedfDrug.atcarray)) {
              vm.newfdrug.atcarray = vm.selectedfDrug.atcarray;
            }

            // Fachinformationen
            if (angular.isString(vm.selectedfDrug.fi)) {
              // "fi" : "/fi_pdf/1-21520.pdf"
              // "fi" : "/eu_pdf/1-21520.pdf"
              vm.newfdrug.fi = vm.selectedfDrug.fi.replace(/_/g, '');
              vm.newfdrug.fi = vm.newfdrug.fi.replace(/\.pdf/g, '');
            }


            if (angular.isString(vm.selectedfDrug.amount) && !angular.isString(vm.selectedfDrug.amounttype)) {
              vm.newfdrug.pkgsize = vm.selectedfDrug.amount;
            }

            // if (angular.isString()) {}

            // Hinweis zum Medikament
            if (vm.selectedfDrug.hint) {
              vm.newfdrug.hint = $sce.trustAsHtml('<div>' + vm.selectedfDrug.hint + '</div>');  // overlay html must be contained in single tag
            }

            // kassenzeichen
            // KZ RE1 RE2
            if (vm.selectedfDrug.kz === 'RE1' || vm.selectedfDrug.kz === 'RE2') {
              vm.newfdrug.re = vm.selectedfDrug.kz;
            }
            if (vm.selectedfDrug.recriteria) {
              $log.debug('recriteria: ', vm.selectedfDrug.recriteria);
              vm.newfdrug.recriteria = $sce.trustAsHtml('<div>' + vm.selectedfDrug.recriteria + '</div>');  // overlay html must be contained in single tag
            }

            // KZ IND
            if (vm.selectedfDrug.kz && vm.selectedfDrug.kz === 'IND') {
              vm.newfdrug.ind = true;
            }

            if (vm.selectedfDrug.indcriteria) {
              vm.newfdrug.indcriteria = $sce.trustAsHtml('<div>' + vm.selectedfDrug.indcriteria + '</div>');
            }


            // All other KZ entries, use popover lookup table
            if (vm.selectedfDrug.kz !== '' && vm.selectedfDrug.kz !== 'RE1' &&
              vm.selectedfDrug.kz !== 'RE2' && vm.selectedfDrug.kz !== 'IND') {
              vm.newfdrug.kz = vm.selectedfDrug.kz;
            }
          }

          function addForeignDrug() {
            delete vm.noFDResults;
            vm.newfdrug.color = 'info';
            vm.newfdrug.foreign = true;
            vm.newfdrug.permanent = true;
            vm.newfdrug.active = true;
            vm.newfdrug.startDate = moment().toISOString();
            vm.newfdrug.print = false;
            vm.patdrugs.drugs.push(vm.newfdrug);
            vm.newfdrug = null;
            vm.selectedDrug = {};
            vm.asyncSelected = '';
            vm.patdrugs.$save();
          }


          // sprhelp texte
          vm.sprgen = ``;

          vm.sprsignature = `W&auml;hlen Sie aus der Liste oder geben Sie eine andere Anweisung ein.
            Sie k&ouml;nnen die Auswahlliste im Einstellungsmenu unter Einstellungen &auml;ndern.`;

          vertxEventBusService.on('patdrugs.update', function (message) {
            // $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
              vm.patdrugs.$refresh().$then(function (drugs) {
                $log.debug('refreshed patdrugs for drughistory: ', vm.patdrugsid);
                // only show vm. drug_saved when change was triggered by this browser
                if (messages[1] === $window.sessionStorage.getItem('sprtabid')) {
                  vm.drug_saved = true;
                  $timeout(function () {
                    delete vm.drug_saved;
                  }, 3000);
                  $log.debug('(drugprescription) saved drug');
                }
              }, function (error) {
                $log.debug('refreshing patdrugs fordrughistory failed: ', error, vm.patdrugsid);
              });
            }
          });

          const configUpdateHandler =  function (message) {
            $log.debug('******** config update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.conf)) {
              if (messages[0] === 'drugsignature') {
                vm.conf.$refresh().$then(function () {
                  $log.debug('******* config refresh drugsignatures');
                }, function (error) {
                  $log.debug('******* config refresh drugsignatures failed: ', error);
                });
              }
            }
          };


          // update dugsignature list TODO: doesnt work, needs backend update message
          vertxEventBusService.on('config.update', {}, configUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
